import GoogleAnalytics from 'react-ga';

const settings = {

	SITENAME : 'Sitename',
	BRAND : 'Brand name',
	STRAPLINE : 'Strapline',
	GA_ID : false, // Analytics ID
	STYLES : {

		palette : [
			{
				label: 'Teal',
				hex : `#375A63`
			},
			{
				label: 'Yellow',
				hex : `#FFFF02`
			},
			{
				label: 'Pink',
				hex : `#FF785A`
			},
			{
				label: 'Gold',
				hex : `#BE9A5D`
			},
			
		],
		type : [
			{
				label : 'intro'
			},
			{
				label : 'heading'
			},
			
			{
				label : 'body'
			},
			
			{
				label : 'small'
			},
			
		],
		icons : [
			{
				label : 'derwent'
			},
			{
				label : 'arrow-left'
			},
			{
				label : 'arrow-right'
			},
			{
				label : 'cross'
			},
			{
				label : 'instagram'
			},
			{
				label : 'facebook'
			},
			{
				label : 'twitter'
			},
			{
				label : 'plus'
			}
		],
		assets : [
			{
				src : '/ui/img/logo.svg',
				width : 213,
				height:16
			},
			
			
		]

	},
	MANIFEST : [],
	GOOGLE_MAPS_API_KEY : 'AIzaSyD6dIsyCYgAE01Y11dk7QX4ylhHF07Vy3c' // Maps ID

	
}



/*
	Init GA
*/

if(settings.GA_ID){
	GoogleAnalytics.initialize({

	    trackingId: settings.GA_ID,
	    debug: true

	});
}

export default settings;





// WEBPACK FOOTER //
// ./src/js/_settings.js